const titles = [
    { value: "administration", label: "Administration of a product/treatment", icon: "/icons/Treatment.svg" },
    { value: "surgery", label: "Surgery", icon: "/icons/Surgery.svg" },
    { value: "behavioral", label: "Behavioral test", icon: "/icons/BehaviorTest.svg" },
    { value: "physiological", label: "Physiological test", icon: "/icons/PhysiologicalTest.svg" },
    { value: "electrophysiological", label: "Electrophysiological test", icon: "/icons/ElectrophysiologicalTest.svg" },
    { value: "irradiation", label: "Irradiation", icon: "/icons/Irradiation.svg" },
    { value: "tumor", label: "Tumor induction", icon: "/icons/TumorInduction.svg" },
    { value: "collection", label: "Collection of samples", icon: "/icons/CollectionOfSamples.svg" },
    { value: "imaging", label: "Imaging", icon: "/icons/Imaging.svg" },
    { value: "marking", label: "Marking", icon: "/icons/Marking.svg" },
    { value: "terminal", label: "Terminal intervention", icon: "/icons/TerminalIntervention.svg" },
    { value: "other", label: "Other" }
  ];
  
  export default titles;
  